import { Injectable } from '@angular/core';
import { PublicService } from '../PublicService';
import { map } from 'rxjs/operators';
import {HttpClient, HttpHeaders} from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class LoginService {
    public constructor(private readonly publicService: PublicService, private readonly http: HttpClient) {
    }
    // 登录
    public login(userName, passWord){
        return this.http
            .post(this.publicService.getApiUrl() + '/user/login',
                {userName, password: passWord, targetSys: 'app'},
                {headers: new HttpHeaders({
                        loginSys: 'app',
                        loginUrl: 'app'
                    })
                })
            .pipe(map(result => result as any))
            .toPromise();

    }
}
